import React, { useState, useEffect } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";

const galleryItems = [
  {
    image: "/images/gallery/hexapi_club.jpeg",
    caption: "HexaPi Club",
    description: "Our AI and Robotics Lab in Tyre.",
    objectPosition: "object-center",
  },
  {
    image: "/images/gallery/anniversary.jpg",
    caption: "Third Anniversary",
    description: "HexaPi's Third Anniversary - August 2023",
    objectPosition: "object-center",
  },
  {
    image: "/images/gallery/event.jpg",
    caption: "Event",
    description: "HexaPi Tech community event and activities",
    objectPosition: "object-top",
  },
  {
    image: "/images/gallery/loubnany.png",
    caption: "Loubnany",
    description: "Proud to be part of Lebanon's tech innovation",
    objectPosition: "object-top",
  },
];

const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Auto-play slider
  useEffect(() => {
    if (!isAutoPlaying) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev === galleryItems.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(interval);
  }, [isAutoPlaying]);

  const goToPrevious = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev === 0 ? galleryItems.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev === galleryItems.length - 1 ? 0 : prev + 1));
  };

  const goToSlide = (index) => {
    setIsAutoPlaying(false);
    setCurrentIndex(index);
  };

  return (
    <section id="gallery" className="py-10 lg:py-14 bg-primary-50">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="section-subheading">Our Work</span>
          <h2 className="section-heading">Gallery</h2>
          <div className="w-20 h-1 bg-primary-500 mx-auto mt-4 rounded-full"></div>
          <p className="text-neutral max-w-2xl mx-auto mt-4">
            A glimpse into our projects, team activities, and innovations
          </p>
        </div>

        {/* Slider Container */}
        <div className="relative">
          {/* Main Slider */}
          <div className="relative overflow-hidden rounded-2xl bg-white shadow-card">
            {/* Slides */}
            <div
              className="flex transition-transform duration-500 ease-out"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {galleryItems.map((item, index) => (
                <div key={index} className="w-full flex-shrink-0">
                  <div className="relative aspect-[16/9] lg:aspect-[21/9]">
                    <img
                      src={item.image}
                      alt={item.caption}
                      className={`w-full h-full object-cover ${item.objectPosition}`}
                    />
                    {/* Caption Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent
                                    flex flex-col justify-end p-6 lg:p-10">
                      <h4 className="text-white font-semibold text-xl lg:text-2xl mb-2">
                        {item.caption}
                      </h4>
                      <p className="text-white/80 text-sm lg:text-base max-w-xl">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={goToPrevious}
              className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 w-8 h-8 md:w-12 md:h-12
                         bg-white/90 hover:bg-white rounded-full shadow-lg
                         flex items-center justify-center transition-all duration-300
                         hover:scale-110"
              aria-label="Previous slide"
            >
              <HiChevronLeft className="w-4 h-4 md:w-6 md:h-6 text-primary-500" />
            </button>
            <button
              onClick={goToNext}
              className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 w-8 h-8 md:w-12 md:h-12
                         bg-white/90 hover:bg-white rounded-full shadow-lg
                         flex items-center justify-center transition-all duration-300
                         hover:scale-110"
              aria-label="Next slide"
            >
              <HiChevronRight className="w-4 h-4 md:w-6 md:h-6 text-primary-500" />
            </button>
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-1.5 md:gap-2 mt-4 md:mt-6">
            {galleryItems.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? "bg-primary-500 w-8"
                    : "bg-primary-200 hover:bg-primary-300"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
